import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Agent`;

const headers = {
  "Content-Type": "multipart/form-data",
};
const ApiAgent = {
  getAllAgency: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getAllAgency`;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getAgentById: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getAgentById?id=` + params;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getAgentDashboard: () => {
    const url = `${baseServiceUrl}/getAgentDashboard`;
    console.log("url==========", url);
    return ServiceApi.get(url);
  },
  getEnumType: () => {
    const url = `${baseServiceUrl}/getAgencyType`;
    return ServiceApi.get(url);
  },
  createAgency: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/createAgency`;
    console.log("url==========", url);
    return ServiceApi.post(url, params);
  },
  createandEditAgentCommand: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/createandEditAgentCommand`;
    console.log("url==========", url);
    return ServiceApi.post(url, params);
  },
  updateAgency: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/updateAgency`;
    console.log("url==========", url);
    return ServiceApi.put(url, params);
  },
  getAllRegion: () => {
    const url = `${baseServiceUrl}/allRegion`;
    return ServiceApi.get(url);
  },
  getLicenseTypeStatus: (params) => {
    // console.log("params==========",params);
    const url = `${baseServiceUrl}/getEnumType`;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getListFiles: (params) => {
    // console.log("params==========",params);
    const url = `${baseServiceUrl}/getListFiles`;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getFile: (params) => {
    // console.log("params==========",params);
    const url = `${baseServiceUrl}/getFile`;
    console.log("url==========", url);
    return ServiceApi.get(url, { params: params, responseType: "blob" });
  },
};

export default ApiAgent;
